var _style, _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPfeil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.32 41.15",
    style: {
      enableBackground: "new 0 0 42.32 41.15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000129196420142752423510000006233254359768290444_);fill:none;stroke:#000000;stroke-width:1.5;}\n\t.st1{clip-path:url(#SVGID_00000168117540255963354600000007926468666737842569_);fill:none;stroke:#000000;stroke-width:1.5;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.23,
    y: 0.53,
    transform: "matrix(0.0536 -0.9986 0.9986 0.0536 -0.517 21.6787)",
    width: 22.81,
    height: 21.16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131344287853116986180000001253537849502712251_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000131344287853116986180000001253537849502712251_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    x1: 0.72,
    y1: 21.34,
    x2: 21.64,
    y2: 0.88
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000150077496306462867820000016735122349831518645_",
    x: 20.56,
    y: -0.29,
    transform: "matrix(0.9986 -0.0536 0.0536 0.9986 -0.5509 1.6854)",
    width: 21.16,
    height: 22.81
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103258553049714285730000014265782302641357243_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150077496306462867820000016735122349831518645_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000103258553049714285730000014265782302641357243_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    x1: 41.61,
    y1: 21.34,
    x2: 20.68,
    y2: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeil);
export default __webpack_public_path__ + "static/media/pfeil.b3eb5bbac2ced66a055595288c67be44.svg";
export { ForwardRef as ReactComponent };